import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delay-exam-4",
  "use": "icon-delay-exam-4-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-delay-exam-4\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FF5600\" cx=\"6\" cy=\"6\" r=\"6\" /><rect fill=\"#FFF\" x=\"5.5\" y=\"2.3\" width=\"1\" height=\"5\" rx=\".5\" /><rect fill=\"#FFF\" x=\"5.3\" y=\"8.2\" width=\"1.5\" height=\"1.5\" rx=\".75\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol